import { MessagesInterface } from '../../../general/model';

export enum Column {
  selector = 'selector',
  name = 'name',
  link = 'link',
  created_at = 'created_at',
  expired_at = 'expired_at',
  email = 'email',
}

export const Messages = {
  loadSharesError: () => ({
    title: `Server request error`,
    message: `Sharing list has not been received`,
  }),
  saveExpirationError: (error: string) => ({
    title: `Server request error`,
    message: `Expiration has not been saved: ${error}`,
  }),
} as MessagesInterface;
